var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.25355 5.67277C4.25355 7.33635 5.29284 8.50087 7.27167 9.04985L11.4538 10.231C12.8257 10.6219 13.5241 11.329 13.5241 12.3271V12.7264C12.3684 13.0258 16.0184 13.0258 14.8627 12.7264V12.3271C14.8627 10.6718 13.8317 9.50734 11.8529 8.95835L7.67075 7.7772C6.30719 7.39458 5.59216 6.67093 5.59216 5.67277V5.28183C6.75617 4.98239 3.10616 4.98239 4.25355 5.28183V5.67277Z",
    fill: "url(#paint0_linear_1951_26404)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59238 5.28189C6.75639 4.98245 7.60447 3.93438 7.60447 2.67838C7.60447 1.2061 6.40718 0 4.92722 0C3.44726 0 2.25 1.2061 2.25 2.67838C2.25 3.93438 3.10638 4.98245 4.25377 5.28189H5.59238Z",
    fill: "url(#paint1_linear_1951_26404)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5924 17.6569C15.7564 17.3574 16.6045 16.3094 16.6045 15.0534C16.6045 13.5811 15.4072 12.375 13.9272 12.375C12.4473 12.375 11.25 13.5811 11.25 15.0534C11.25 16.3094 12.1064 17.3574 13.2538 17.6569H14.5924Z",
    fill: "url(#paint2_linear_1951_26404)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1951_26404",
    x1: 4.02734,
    y1: 5.05725,
    x2: 4.02734,
    y2: 12.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1951_26404",
    x1: 2.25,
    y1: 0,
    x2: 2.25,
    y2: 5.28189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1951_26404",
    x1: 11.25,
    y1: 12.375,
    x2: 11.25,
    y2: 17.6569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsPath);
export default __webpack_public_path__ + "static/media/es_path.d2a32975.svg";
export { ForwardRef as ReactComponent };